import { functions } from '@/firebase'
import { traceHttpsCallable } from '@/utils/sentry'
import type {
  CreateClassScheduleCallableResult,
  CreateClassScheduleRequest,
  CreateInstructorCallableResult,
  CreateInstructorRequest,
  CreateStandaloneClassInstanceCallableResult,
  CreateStandaloneClassInstanceRequest,
  EndViewingSessionRequest,
  EndViewingSessionResponse,
  GenerateSignedUrlRequest,
  GenerateSignedUrlResponse,
  PreviewClassScheduleUpdateCallableResult,
  PreviewClassScheduleUpdateRequest,
  UpdateClassInstanceCallableResult,
  UpdateClassInstanceRequest,
  UpdateClassScheduleCallableResult,
  UpdateClassScheduleRequest,
  UpdateInstructorCallableResult,
  UpdateInstructorRequest,
  UpdateViewingProgressRequest,
  UpdateViewingProgressResponse,
} from 'functions-node-classes/src/types'

type ClassMutationResponse = { success: boolean; message?: string }

export const Classes = {
  createStandaloneClassInstance: traceHttpsCallable<
    CreateStandaloneClassInstanceRequest,
    CreateStandaloneClassInstanceCallableResult
  >(functions, 'classes_createStandaloneClassInstance'),
  updateClassInstance: traceHttpsCallable<
    UpdateClassInstanceRequest,
    UpdateClassInstanceCallableResult
  >(functions, 'classes_updateClassInstance'),
  updateClassSchedule: traceHttpsCallable<
    UpdateClassScheduleRequest,
    UpdateClassScheduleCallableResult
  >(functions, 'classes_updateClassSchedule'),
  createClassSchedule: traceHttpsCallable<
    CreateClassScheduleRequest,
    CreateClassScheduleCallableResult
  >(functions, 'classes_createClassSchedule'),
  previewClassScheduleUpdate: traceHttpsCallable<
    PreviewClassScheduleUpdateRequest,
    PreviewClassScheduleUpdateCallableResult
  >(functions, 'classes_previewClassScheduleUpdate'),
  updateInstructor: traceHttpsCallable<UpdateInstructorRequest, UpdateInstructorCallableResult>(
    functions,
    'classes_updateInstructor',
  ),
  createInstructor: traceHttpsCallable<CreateInstructorRequest, CreateInstructorCallableResult>(
    functions,
    'classes_createInstructor',
  ),
  generateSignedUrl: traceHttpsCallable<GenerateSignedUrlRequest, GenerateSignedUrlResponse>(
    functions,
    'recordings_generateSignedUrl',
  ),
  updateViewingProgress: traceHttpsCallable<
    UpdateViewingProgressRequest,
    UpdateViewingProgressResponse
  >(functions, 'recordings_updateViewingProgress'),
  endViewingSession: traceHttpsCallable<EndViewingSessionRequest, EndViewingSessionResponse>(
    functions,
    'recordings_endViewingSession',
  ),
  evaluateSchedulesNow: traceHttpsCallable<object, ClassMutationResponse>(
    functions,
    'classes_evaluateSchedulesNow',
  ),
}
